import { render, staticRenderFns } from "./AChip.vue?vue&type=template&id=357ffffe&scoped=true&"
import script from "./AChip.vue?vue&type=script&lang=js&"
export * from "./AChip.vue?vue&type=script&lang=js&"
import style0 from "./AChip.vue?vue&type=style&index=0&id=357ffffe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357ffffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
